const INDIAN_VEHICLE_NUMBER_REGEX =
  /^(?:[A-Z]{2}\d{1,2}[A-Z]{0,3}\d{1,4}|\d{2}BH\d{4}[A-Z]{1,2})$/;

export const normalizeIndianVehicleNumber = (vehicleNumber: string) =>
  vehicleNumber.trim().toUpperCase().replace(/[\s-]/g, "");

export const isValidIndianVehicleNumber = (vehicleNumber: string) =>
  INDIAN_VEHICLE_NUMBER_REGEX.test(
    normalizeIndianVehicleNumber(vehicleNumber),
  );
